//import { sound } from "@pixi/sound";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { Container, DestroyOptions, Sprite } from "pixi.js";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";
import { GameConstants } from "../../gameClientEvents/GameConstants";

export class BackGround extends DisplayObject {
    private backgroundImageCont: Container = new Container();
    private background: Container = new Container();
    private backGroundSpine: Spine | null = null;
    private currentAnimName: string | null = null;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
    }

    public override destroy(options?: DestroyOptions): void {
        super.destroy(options);
    }

    private init(): void {

        this.backgroundImageCont.addChild(Sprite.from("background"));
        this.backgroundImageCont.label = "backgroundImageCont";
        this.backGroundSpine = Spine.from({ skeleton: 'baseBackgroundSkel', atlas: 'baseBackgroundAtlas' });
        this.backGroundSpine.label = "backgroundSpine";
        this.playAnimation("basegame", true);
        this.backGroundSpine?.position.set(GameConstants.BACKGROUND_SIZE / 2, GameConstants.BACKGROUND_SIZE / 2);
        this.backgroundImageCont.addChild(this.backGroundSpine);
        this.addChild(this.backgroundImageCont);
        this.addChild(this.background);
    }

    public playAnimation(animationName: string, loop: boolean = true): void {
        if (!this.backGroundSpine) return;

        const current = this.backGroundSpine.state.getCurrent(0)?.animation?.name ?? this.currentAnimName;
        if (current === animationName) return;

        this.currentAnimName = animationName;
        this.backGroundSpine.state.setAnimation(0, animationName, loop);
    }

    public override setPositionResize(orientation: string): void {
        const isLandscape = Manager.screenwidth > Manager.screenHeight;
        const scale = isLandscape ? Math.min(Manager.screenwidth / GameConstants.GAME_RES_WIDTH, Manager.screenHeight / GameConstants.GAME_RES_HEIGHT) : Math.min(Manager.screenwidth / GameConstants.GAME_RES_HEIGHT, Manager.screenHeight / GameConstants.GAME_RES_WIDTH);
        const bgScale = Math.max(scale, Manager.screenwidth / GameConstants.BACKGROUND_SIZE, Manager.screenHeight / GameConstants.BACKGROUND_SIZE);
        this.background?.scale.set(scale, scale);
        const xPos = (GameConstants.BACKGROUND_SIZE * scale - Manager.screenwidth) / 2;
        const yPos = (GameConstants.BACKGROUND_SIZE * scale - Manager.screenHeight) / 2;
        this.background?.position.set(-xPos, -yPos);
        this.backgroundImageCont?.scale.set(bgScale, bgScale);
        const bgXPos = (GameConstants.BACKGROUND_SIZE * bgScale - Manager.screenwidth) / 2;
        const bgYPos = (GameConstants.BACKGROUND_SIZE * bgScale - Manager.screenHeight) / 2;
        this.backgroundImageCont?.position.set(-bgXPos, -bgYPos);
        if (orientation === "LANDSCAPE") {
            this.setPosition(this.config.landscape.posX, this.config.landscape.posY);
            this.setScale(this.config.landscape.scale, this.config.landscape.scale);
        } else {
            this.setPosition(this.config.portrait.posX, this.config.portrait.posY);
            this.setScale(this.config.portrait.scale, this.config.portrait.scale);
        }
    }
}
